const base = {
	searchBarMain: {
		searchButton: {
			label: 'Suchen',
		},
		travelType: {
			hotelOnly: 'Nur Hotel',
			package: 'Pauschalreise',
			cruise: 'Kreuzfahrten',
		},
	},
	close: 'Schließen',
	alternativeFlights: {
		currentOffer: 'Originalflug',
	},
	filtersSection: {
		dealsOnly: {
			title: 'Restplätze',
			label: 'Angebote mit Preissenkung',
		},
	},
	flightDetail: {
		header: 'Voraussichtliche Flugdaten',
		legalText:
			'Der Reiseveranstalter behält sich Änderungen der geplanten Flugzeiten im Rahmen der gesetzlichen und vertraglichen Möglichkeiten vor.',
	},
	button: {
		ok: 'Übernehmen',
		cancel: 'Verwerfen',
		abort: 'Abbrechen',
		reset: 'Zurücksetzen',
	},
	calendar: {
		confirmDialog: {
			title: 'Möchten Sie die Auswahl verwerfen?',
		},
		daysOfWeek: {
			monday: 'Montag',
			tuesday: 'Dienstag',
			wednesday: 'Mittwoch',
			thursday: 'Donnerstag',
			friday: 'Freitag',
			saturday: 'Samstag',
			sunday: 'Sonntag',
		},
	},
	offers: {
		title: 'Angebote',
		packageDeals: 'Pauschalreise-Angebote',
		hotelOffers: 'Hotelangebote',
	},
	pricing: {
		surcharge: 'Aufpreis',
		discount: 'Abschlag',
		total: 'Gesamtpreis',
	},
	offer: {
		details: 'Angebotsdetails',
		verifyOffer: 'Angebot prüfen',
		notAvailable: 'Nicht mehr verfügbar',
		addToCart: 'Zur Buchung',
		flight: {
			details: 'Flugdetails',
			stops: 'Direktflug | {stop} Stop | {stop} Stops',
		},
	},
	airportFilter: {
		title: 'Abflughafen',
		modalTitle: 'Flughafen',
		notFoundMessage: 'Für deine Suche gibt es leider keine passenden Filter.',
	},
	dropdownFilterType: {
		select: '{title} auswählen',
	},
	any: 'Beliebig',
	destination: {
		label: 'Reiseziel, Hotel, Ort, ...',
		modal: {
			searchInput: 'Suchen',
			searchHistory: 'Zuletzt gesucht',
			favouriteDestinations: 'Beliebteste Destinationen',
			countries: 'Land',
			hotels: 'Hotel',
			cities: 'Stadt',
			regions: 'Region',
			regionGroups: 'Destinationen',
		},
	},
	autocomplete: {
		airportLabels: {
			ownArrival: 'Eigene Anreise',
			departure: 'Flug ab ',
			flightIncluded: 'Inkl. Flug',
		},
		travelers: '{travelers} Erwachsener | {travelers} Erwachsene',
		children: '{children} Kind | {children} Kinder',
		errorMessage: {
			serverError: 'Der Server ist im Augenblick nicht erreichbar.',
			noResult: 'Bitte geben Sie einen Suchbegriff ein.',
			tryAgain: 'Bitte versuchen Sie es in Kürze erneut.',
		},
	},
	formField: {
		min: '(mind.)',
	},
} as const;

export type BaseStructure = typeof base;

export default base;
